import { postRequestAPIConstants } from '../constants'

function getProcessedResults(slug, response = {}) {
    const result = (response.response || {}).results || []

    if (slug === 'ai/image/tagging' || slug === 'ai/text/detect-language') {
        return result
    }

    if (typeof result === 'string') {
        return result || 'Empty response' // for a 'ai/text/transliterate' string is expected
    }

    if (slug === 'ai/text/translate') {
        return result.join(' ') || 'Empty response'
    }

    // dictionary -> {}
    // detect-intent, sentiment -> list of dictionaries
    return JSON.stringify(result, null, 4) || 'Empty response'
}

export default (state = {}, action = {}) => {
    const { data = {} } = action
    const { slug = '', provider = {}, pair } = data
    const slugState = state[slug] || {}
    const pendingProviders = slugState.pendingProviders || {}
    const readyProviders = slugState.readyProviders || {}
    const failedProviders = slugState.failedProviders || {}
    const errors = slugState.errors || {}
    const results = slugState.results || {}
    // the indentifier of the demo form state (selected language(s))
    switch (action.type) {
        case postRequestAPIConstants.RESET: {
            return {
                ...state,
                [slug]: {
                    results: {},
                    failedProviders: {},
                    pendingProviders: [],
                    readyProviders: {},
                    activeProvider: '',
                },
            }
        }
        case postRequestAPIConstants.REQUEST: {
            return {
                ...state,
                [slug]: {
                    ...slugState,
                    activeProvider: provider.id,
                    pendingProviders: [provider.id, ...pendingProviders],
                    pending: true,
                },
            }
        }
        case postRequestAPIConstants.SUCCESS: {
            const nextReadyProvidersForPair = readyProviders[pair] || []
            if (nextReadyProvidersForPair.indexOf(provider.id) === -1) {
                // mark the current provider as a provider with results
                nextReadyProvidersForPair.push(provider.id)
            }

            return {
                ...state,
                [slug]: {
                    ...slugState,
                    ...action.response.data,
                    pendingProviders: pendingProviders.filter(
                        el => el !== provider.id
                    ),
                    readyProviders: {
                        ...readyProviders,
                        // TODO remove the current provider from the failed providers list
                        [pair]: nextReadyProvidersForPair,
                    },
                    results: {
                        ...results,
                        [pair]: {
                            ...(results[pair] || {}),
                            [provider.id]: getProcessedResults(slug, action),
                        },
                    },
                    pending: false,
                },
            }
        }
        case postRequestAPIConstants.FAILURE: {
            return {
                ...state,
                [slug]: {
                    ...slugState,
                    pendingProviders: pendingProviders.filter(
                        el => el !== provider.id
                    ),
                    failedProviders: {
                        ...failedProviders,
                        [pair]: [provider.id, ...(failedProviders[pair] || [])],
                    },
                    errors: {
                        ...errors,
                        [pair]: {
                            ...(errors[pair] || {}),
                            [provider.id]: action.error,
                        },
                    },
                    pending: false,
                },
            }
        }
        default:
            return state
    }
}



// WEBPACK FOOTER //
// /usr/src/app/frontend/src/connectors/redux/reducers/postRequestAPI.js